import * as Api from '@ViewModels';

const getPrimaryEmailAddress = (principal: Api.IPrincipal) => {
	let primaryEmailAddress: Api.EmailAddress;
	if (principal) {
		primaryEmailAddress = principal.primaryEmail ? principal.primaryEmail : null;
		if (!primaryEmailAddress || !primaryEmailAddress.value) {
			primaryEmailAddress = null;

			// try as a contact
			if (Object.prototype.hasOwnProperty.call(principal, 'emailAddresses')) {
				const contact = principal as Api.IContact;

				primaryEmailAddress =
					!!contact.emailAddresses && contact.emailAddresses.length > 0
						? contact.emailAddresses.find(x => !!x.value)
						: null;
			}
		}
	}

	return primaryEmailAddress;
};

export const getDisplayName = (principal: Api.IPrincipal, short = false) => {
	if (!principal) {
		return '';
	}

	if (Boolean(principal.firstName) && !principal.lastName) {
		return principal.firstName;
	}

	if (Boolean(principal.firstName) && Boolean(principal.lastName)) {
		if (principal.lastName.toLowerCase().trim() === 'n/a') {
			return principal.firstName;
		}

		return `${principal.firstName} ${short ? `${principal.lastName.charAt(0)}.` : principal.lastName}`;
	}

	const primaryEmail = getPrimaryEmailAddress(principal);
	if (primaryEmail) {
		return primaryEmail.value;
	}

	return '';
};

export const getPrincipalInitials = (principal: Api.IPrincipal): string => {
	if (!principal) {
		return '';
	}

	if (Boolean(principal.firstName) && !principal.lastName) {
		return `${principal.firstName.substring(0, 1)} `;
	}

	if (Boolean(principal.firstName) && Boolean(principal.lastName)) {
		if (principal.lastName.toLowerCase().trim() === 'n/a') {
			return `${principal.firstName.substring(0, 1)} `;
		}

		return `${principal.firstName.substring(0, 1)}${principal.lastName.substring(0, 1)}`;
	}

	if (principal.primaryEmail?.value) {
		return principal.primaryEmail.value.substring(0, 1);
	}

	return '';
};

export const getCompanyInitials = (company: Api.ICompany): string => {
	return (company?.companyName || '').split(' ').reduce((p, c, i) => (i < 2 ? `${p}${c.substring(0, 1)}` : p), '');
};
